import { ActionPermissionState } from '../types';
import { GzButtonWebComponent } from '../../ui/gzButton';
import { LitElement } from 'lit';
import { GzTooltipWebComponent } from '../../ui/gzTooltip';

export class ButtonHelper {
  private dependencies: any;

  constructor(dependencies) {
    this.dependencies = dependencies;
  }

  isButtonEnabled(state: ActionPermissionState) {
    return state === ActionPermissionState.ACTIVE;
  }

  getTooltipString(state: ActionPermissionState): string | undefined {
    switch (state) {
      case ActionPermissionState.MISSING_NETWORK:
        return this.dependencies.translateFn('Network administrative privileges are required.');
      case ActionPermissionState.REMOVED:
        return this.dependencies.translateFn('This endpoint was removed.');
      case ActionPermissionState.OTHER:
        return this.dependencies.translateFn('A communication error has occurred. Please try again later. ');
      case ActionPermissionState.ISOLATED:
        return this.dependencies.translateFn('This endpoint is already isolated.');
      case ActionPermissionState.NO_HASH:
        return this.dependencies.translateFn('No hash available.');
      case ActionPermissionState.WRONG_ENDPOINT_TYPE:
        return this.dependencies.translateFn('The action is not supported by the endpoint.');
      case ActionPermissionState.NO_POLICY:
        return this.dependencies.translateFn('The policy active at the time of the detection is no longer available.');
      case ActionPermissionState.MISSING_POLICIES_READ:
        return this.dependencies.translateFn('You require the Manage Endpoint Settings right to perform this action.');
      case ActionPermissionState.MISSING_POLICIES_WRITE:
        return this.dependencies.translateFn('You require the Manage Endpoint Settings right to perform this action.');
      case ActionPermissionState.MISSING_FEATURE:
        return this.dependencies.translateFn('You require permission to access the Risk Management feature. Contact a user with Company Administrator role.');
      default:
        return undefined;
    }
  }

  handleTooltips(button: GzButtonWebComponent | HTMLElement, state: ActionPermissionState): LitElement | HTMLElement {
    const tooltipMessage = this.getTooltipString(state);

    if (tooltipMessage) {
      const gzToolTip = new GzTooltipWebComponent();
      gzToolTip.tooltipText = tooltipMessage;
      gzToolTip.appendChild(button);
      return gzToolTip;
    }

    return button;
  }
}
